module.exports = __webpack_public_path__ + "static/media/user2.8028c1a0.png";